import {
  useSelectedNode,
  useSelectedNodeOperations,
} from 'state/canvas/selected-node';

import Konva from 'konva';
import { SurfaceNodeUnion } from 'graphql/types';

interface UseNodeContextMenuVisibility {
  isVisible: boolean;
  toggleVisibility(event: Konva.KonvaEventObject<any>): void;
}

export default function useNodeContextMenuVisibility(
  node: SurfaceNodeUnion,
): UseNodeContextMenuVisibility {
  useSelectedNode();

  const {
    isNodeSelected,
    setSelectedNode,
    clearSelectedNode,
  } = useSelectedNodeOperations();

  const isVisible = isNodeSelected(node);

  function toggleVisibility(event) {
    event.cancelBubble = true;
    isVisible ? clearSelectedNode() : setSelectedNode(node.id);
  }

  return { isVisible, toggleVisibility };
}
